<script setup>
import { useProjectStore } from '@/stores/project';

const projectStore = useProjectStore();

const props = defineProps({
  description: {
    type: String,
    default: 'No content available yet.',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    required: false,
  },
  heightClass: {
    type: String,
    default: 'h-full',
  },
  buttonDisabled: {
    type: Boolean,
    default: false,
  },
  buttonIcon: {
    type: String,
    default: '',
  },
  buttonIconPos: {
    type: String,
    default: 'left',
  },
  buttonPermission: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="grid items-center" :class="heightClass">
    <div class="flex flex-col items-center gap-3">
      <span
        v-if="icon"
        :class="icon"
        class="text-6xl font-bold text-surface-700 dark:text-surface-300"
      ></span>
      <p class="text-xl">
        {{ description }}
      </p>

      <Button
        v-if="buttonLabel && projectStore.currentProject"
        :label="buttonLabel"
        :disabled="buttonDisabled"
        :icon="buttonIcon"
        :icon-pos="buttonIconPos"
        @click="$emit('create')"
        v-permission="buttonPermission"
        size="large"
      />
    </div>
  </div>
</template>
